module.exports = __webpack_public_path__ + "static/media/onNoChatSelected.a405db7d.jpg";